import {
  MDBAutocomplete,
  MDBBtn,
  MDBCheckbox,
  MDBIcon,
  MDBInput,
  MDBModalFooter,
  MDBSelect,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import ReactDOM from "react-dom";
import {
  unFormatNumber,
  validatePhoneNumber,
} from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import OperatorSelect from "./OperatorSelect";
import { externalNumberearch } from "../../../apiclients/streamsapi_bridge";

const DEFAULT_FIELD_NAMES = {
  timeout: "routing.busy_or_no_answer.timeout",
  timeoutFlag: "routing.busy_or_no_answer.timeout_flag",
  timeoutrouting: "routing.busy_or_no_answer.timeout_routing",
  timeoutdesttyperouting: "routing.busy_or_no_answer.timeout_dest_type",
  cidPassFlag: "routing.busy_or_no_answer.cid_pass_flag",
  cidPass: "routing.busy_or_no_answer.cid_pass",
  destinationType: "routing.busy_or_no_answer.destination_type",
  destinationvalue: "routing.busy_or_no_answer.value",
  ph_num: "routing.busy_or_no_answer.phnumber",
  entityType: "routing.busy_or_no_answer.entity_type",
};
function BusyNoAnswerRoute({
  operatorsList,
  operatorValue,
  fieldNames = DEFAULT_FIELD_NAMES,
  CallerList,
  executeSetting,
  aaFlag,
  assocCallFlows,
  setIsloading,
  mainLabel = "Select If Busy or No Answer Route",
  mainRouteError = "Please Select If Busy or No Answer Route",
  command,
}) {
  const {
    setValue,
    watch,
    control,
    register,
    unregister,
    formState: { errors },
    clearErrors,
    setError,
  } = useFormContext();
  const navigate = useNavigate();
  const [userList, setUserList] = useState([]);
  const [callerIDList, setCallerIDList] = useState([]);
  const [hgList, setHgList] = useState([]);
  const [userVoicemail, setuserVoicemail] = useState([]);
  const [groupVoicemail, setgroupVoicemail] = useState([]);
  const [autoAttendList, setautoAttendList] = useState([]);
  const { t, i18n } = useTranslation();
  const [mainSelectedType, setMainSelectedType] = useState(null);
  const [dbSelectedValue, setdbSelectedValue] = useState(null);
  const [cidPassValue, setcidPassValue] = useState("-1");
  const [selectedType, setSelectedType] = useState(null);
  const [selectedInnerType, setSelectedInnerType] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedInnerValue, setSelectedInnerValue] = useState(null);
  const [didSearchError, setdidSearchError] = useState("");
  const [innerDidSearchError, setinnerDidSearchError] = useState("");
  const [isExternalNumber, setisExternalNumber] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [open, setOpen] = useState(false);

  const OPERATOR_TYPES = {
    Users: 1,
    Voicemails: 6,
    "System Extensions": 0,
    // "Hunt Group Voicemail": 6,
    // "Auto Attendant": 0,
    "External Numbers": 4,
    // "Search DID": 5,
    ...(aaFlag && {
      Operator: 11,
      Directory: 13,
    }),
  };
  const OPERATOR_INNER_TYPES = {
    Users: 1,
    Voicemails: 6,
    "System Extensions": 0,
    // "Hunt Group Voicemail": 6,
    // "Auto Attendant": 0,
    // "Search DID": 5,
    // ...(aaFlag && {
    //   Operator: 11,
    //   Directory: 13,
    // }),
  };

  // console.log("errors ::::::::::::::::" + JSON.stringify(errors));

  useEffect(() => {
    if (executeSetting) {
      setSelectedType(null);
      setSelectedInnerType(null);
      setSelectedValue(null);
      setSelectedInnerValue(null);
      setdidSearchError("");
      setinnerDidSearchError("");
      setMainSelectedType(null);
      setdbSelectedValue(null);
    }
  }, [executeSetting]);

  useEffect(() => {
    if (operatorsList && Object.entries(operatorsList).length > 0) {
      console.log(
        "operatorsList :::::::::::::::::" + JSON.stringify(operatorsList)
      );
      setUserList(operatorsList?.user ?? []);
      setHgList(operatorsList?.hggroup ?? []);
      setautoAttendList(operatorsList?.aagroup ?? []);
      setuserVoicemail(operatorsList?.userVoicemail ?? []);
      setgroupVoicemail(operatorsList?.groupVoicemail ?? []);
    }
  }, [operatorsList]);

  useEffect(() => {
    if (operatorValue) {
      if (
        operatorValue.destination_type &&
        parseInt(operatorValue.destination_type) === 4
      ) {
        setSelectedValue("External Numbers");
        setdbSelectedValue("External Numbers");
        setMainSelectedType("External Numbers");
        setSelectedType("External Numbers");
        setisExternalNumber(true);
        setcidPassValue(
          operatorValue?.cid_pass ? operatorValue.cid_pass : "-1"
        );
        setSelectedInnerValue(
          // (operatorValue?.timeout_routing?.title ?? "") +
          //   "" +
          (operatorValue?.timeout_routing?.extension
            ? `${operatorValue.timeout_routing.extension} : ${
                operatorValue?.timeout_routing?.title ?? ""
              }`
            : operatorValue?.timeout_routing?.title ?? "") +
            "" +
            (operatorValue?.timeout_routing?.category
              ? ` : ${operatorValue.timeout_routing.category}`
              : "")
        );
      } else {
        setSelectedValue(
          // operatorValue.title +
          //   "" +
          (operatorValue.extension
            ? `${operatorValue.extension} : ${operatorValue.title}`
            : operatorValue.title) +
            "" +
            (operatorValue.category ? ` : ${operatorValue.category}` : "")
        );
        setMainSelectedType(
          // operatorValue.title +
          //   "" +
          (operatorValue.extension
            ? `${operatorValue.extension} : ${operatorValue.title}`
            : operatorValue.title) +
            "" +
            (operatorValue.category ? ` : ${operatorValue.category}` : "")
        );
        setdbSelectedValue(
          // operatorValue.title +
          //   "" +
          (operatorValue.extension
            ? `${operatorValue.extension} : ${operatorValue.title}`
            : operatorValue.title) +
            "" +
            (operatorValue.category ? ` : ${operatorValue.category}` : "")
        );
      }
    } else {
      setSelectedValue(null);
      setMainSelectedType(null);
      setdbSelectedValue(null);
    }
  }, [operatorValue]);

  const displayData = {
    Users: userList,
    Voicemails: userVoicemail,
    "System Extensions": hgList,
    // "Hunt Group Voicemail": groupVoicemail,
    // "Auto Attendant": autoAttendList,
    "External Numbers": [],
    // "Search DID": [],
    ...(aaFlag && {
      // Operator: [],
      Directory: [],
    }),
  };
  const displayInnerData = {
    Users: userList,
    Voicemails: userVoicemail,
    "System Extensions": hgList,
    // "Hunt Group Voicemail": groupVoicemail,
    // "Auto Attendant": autoAttendList,
    // "Search DID": [],
    //   ...(aaFlag && {
    //     Operator: [],
    //     Directory: [],
    //   }
    // ),
  };

  // const getError = (fieldPath) => {
  //   const parts = fieldPath.split(".");
  //   let result = errors;
  //   for (const part of parts) {
  //     if (!result) return undefined;
  //     result = result[part];
  //   }
  //   return result?.message;
  // };

  const getError = (fieldPath) => {
    if (!fieldPath) return undefined;

    // Convert "routing[35].destination_type" to "routing.35.destination_type"
    const path = fieldPath.replace(/\[(\d+)\]/g, ".$1");

    return path
      .split(".")
      .reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        errors
      )?.message;
  };

  // console.log(
  //   "destinationType :::::::::::" + watch(fieldNames.destinationType)
  // );
  const isValidNumber = (value) => {
    const cleaned = value.replace(/[+\s]/g, "");
    return /^\d+$/.test(cleaned);
  };

  const [typingTimeout, setTypingTimeout] = useState(null);
  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  const onSearch = (value) => {
    setValue(fieldNames.ph_num, value, {
      shouldDirty: true,
    });
    let term = value.toLowerCase();
    // if (selectedType === "Search DID") {
    term = unFormatNumber(term);
    if (!term) {
      clearErrors(fieldNames.ph_num);
      setdidSearchError("");
      setisExternalNumber(false);
      return;
    }

    if (term.length < 10 || term.length > 11) {
      setisExternalNumber(false);
      return;
    }
    if (!isValidNumber(term)) {
      setdidSearchError(
        "Please provide a valid internal number. It should be 10 to 11 digits long."
      );
    } else if (term && term.length > 9 && term.length < 12) {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      const newTimeout = setTimeout(() => {
        sendApIRequest(term, [], 1);
      }, 500);
      // Update the typingTimeout state with the new timeout
      setTypingTimeout(newTimeout);
      clearErrors(fieldNames.ph_num);
    } else {
      setdidSearchError(
        "Please provide a valid internal number. It should be 10 to 11 digits long."
      );
    }
    // }
  };

  const sendApIRequest = async (searchValue, filteredData, innerFlag) => {
    try {
      if (searchValue.trim() !== "") {
        setIsloading(true);
        const serverResponse = await externalNumberearch(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          searchValue
        );
        setIsloading(false);
        const responseData = await serverResponse.json();
        console.log(
          "Response for the search :::::: " + JSON.stringify(responseData)
        );
        if (!responseData.status || responseData.status !== "success") {
          if (responseData.message?.errors) {
            responseData.message.errors.forEach((err) => {
              if (innerFlag) {
                const errmessage = err.message?.includes(
                  "unallocated internal number"
                )
                  ? `${
                      err.message.split(".")[0]
                    }. Please provide a valid internal number.`
                  : err.message;
                // setdidSearchError(errmessage);
                setError(fieldNames.ph_num, {
                  type: "server",
                  message: errmessage,
                });
              } else {
                // setdidSearchError(err.message);
                setError(fieldNames.ph_num, {
                  type: "server",
                  message: err.message,
                });
              }
            });
          }
        } else {
          console.log(
            "reponse for the data ::::::::::::::: " +
              JSON.stringify(responseData)
          );
          if (responseData.routing_obj) {
            const newValue = {
              ...responseData.routing_obj,
              title: responseData?.routing_obj?.title ?? "",
              extensions: responseData?.routing_obj?.extensions ?? "",
            };
            const updatedDefaultData = [...filteredData, newValue];
            setFilteredOptions(updatedDefaultData);
            clearErrors(fieldNames.ph_num);
            setOpen(true);
          } else {
            clearErrors(fieldNames.ph_num);
            setisExternalNumber(true);
            setValue(fieldNames.destinationType, 4, { shouldDirty: true });
            setOpen(false);
          }
        }
      }
    } catch (error) {
      console.log(`Error in sendApIRequest for address search :::: ${error}`);
    }
  };

  const handleSelect = (data) => {
    setSelectedValue(data);
    setMainSelectedType(data);
    setOpen(false);
    if (data && data.split(":").length === 3) {
      const objList = data.split(":");
      setSelectedType(
        objList[2] && objList[2]?.trim() === "User"
          ? "Users"
          : "System Extensions"
      );
      const item = filteredOptions.find(
        (item) => parseInt(item.extensions) === parseInt(objList[0].trim())
      );

      const destinationsType = item.category === "User" ? 1 : 0;
      setValue(fieldNames.destinationType, destinationsType, {
        shouldDirty: true,
      });
      setValue(fieldNames.destinationvalue, item.agentid ?? item.code + "", {
        shouldDirty: true,
      });
      // setValue(fieldNames.ph_num, "", { shouldDirty: true });
      unregister(fieldNames.ph_num);
      clearErrors(fieldNames.ph_num);
    }
  };

  console.log(
    "fieldNames.destinationvalue ::::::::: " +
      watch(fieldNames.destinationvalue)
  );
  return (
    <>
      <OperatorSelect
        name={fieldNames.destinationType}
        label={mainLabel}
        operatorTypes={OPERATOR_TYPES}
        operatorData={displayData}
        typeMapping={OPERATOR_TYPES}
        onTypeChange={setMainSelectedType}
        didSearchError={didSearchError}
        setdidSearchError={setdidSearchError}
        oldselectedValue={selectedValue}
        oldselectedtype={selectedType}
        destinationvalue={fieldNames.destinationvalue}
        entityType={fieldNames.entityType}
        executeSetting={executeSetting}
        aaFlag={aaFlag}
        assocCallFlows={assocCallFlows}
        mainRouteError={mainRouteError}
        dbSelectedValue={dbSelectedValue}
        command={command}
        setisExternalNumber={setisExternalNumber}
        routingname={fieldNames.destinationvalue}
      />
      {mainSelectedType === "External Numbers" &&
        displayData["External Numbers"].length === 0 && (
          <>
            {/* <MDBInput
              type="text"
              className="mt-3"
              placeholder="Enter External Number"
              {...register(fieldNames.ph_num, {
                required: "External Number is required",
                validate: validatePhoneNumber,
              })}
            /> */}

            <Controller
              name={fieldNames.ph_num}
              control={control}
              rules={{
                required: "External Number is required",
                validate: validatePhoneNumber,
              }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <MDBAutocomplete
                    autoFocus
                    className="mt-3"
                    data={filteredOptions}
                    placeholder="Search DID or Enter External Number"
                    onSearch={onSearch}
                    open={open}
                    value={watch(fieldNames.ph_num)}
                    onSelect={(value) => handleSelect(value)}
                    displayValue={(item) => {
                      return `${
                        item.extensions
                          ? `${item.extensions} : ${item.title}`
                          : item.title
                      } ${item.category ? ` : ${item.category}` : ""}`;
                    }}
                  />

                  {getError(fieldNames.ph_num) && (
                    <p className="text-danger">{getError(fieldNames.ph_num)}</p>
                  )}
                </>
              )}
            />
          </>
        )}

      {isExternalNumber && (
        <>
          <div className="mt-2 d-flex align-itemd-center justify-content-between w-100">
            <div className="tel-numbers fw-bold">{t("Timeout")}</div>
            <MDBCheckbox
              name="checkNoLabel"
              id="timeOutFlag"
              checked={watch(fieldNames.timeoutFlag)}
              aria-label="..."
              onChange={(e) => {
                setValue(fieldNames.timeoutFlag, e.target.checked, {
                  shouldDirty: true,
                });
                if (e.target.checked) {
                  clearErrors(fieldNames.timeout);
                  clearErrors(fieldNames.timeoutdesttyperouting);
                } else {
                  setValue(fieldNames.timeout, 0, { shouldDirty: false });
                  setValue(fieldNames.timeoutdesttyperouting, -1, {
                    shouldDirty: false,
                  });
                  setValue(fieldNames.timeoutrouting, "", {
                    shouldDirty: false,
                  });
                  setSelectedInnerType(null);
                  setSelectedInnerValue(null);
                  clearErrors(fieldNames.timeout);
                  clearErrors(fieldNames.timeoutdesttyperouting);
                }
              }}
            />
          </div>
          <div className="d-flex w-100">
            <div className="phoneselect w-100">
              <input
                placeholder="Search or Enter External number"
                disabled={!watch(fieldNames.timeoutFlag)}
                type="text"
                {...register(fieldNames.timeout, {
                  valueAsNumber: true,
                  required: "Timeout is required",
                  validate: (value) => {
                    if (!watch(fieldNames.timeoutFlag)) return true; // skip if flag not set

                    if (value === 0) {
                      return "Timeout should not be zero";
                    }

                    if (value < 5 || value > 60) {
                      return "The ring time is invalid. It must be a number between 5 and 60.";
                    }

                    return true;
                  },
                })}
                className="w-100 form-control"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.stopPropagation();
                    event.preventDefault();
                  }
                }}
              />
              <span className="seconds">{t("seconds")}</span>
              {getError(fieldNames.timeout) && (
                <p className="text-danger">{getError(fieldNames.timeout)}</p>
              )}
            </div>
          </div>

          <div className="mt-2 d-flex align-itemd-center justify-content-between w-100">
            <div className="tel-numbers fw-bold">{t("RouteonTimeout")}</div>
          </div>
          <OperatorSelect
            name={fieldNames.timeoutdesttyperouting}
            operatorTypes={OPERATOR_INNER_TYPES}
            operatorData={displayInnerData}
            typeMapping={OPERATOR_INNER_TYPES}
            didSearchError={innerDidSearchError}
            setdidSearchError={setinnerDidSearchError}
            oldselectedValue={selectedInnerValue}
            oldselectedtype={selectedInnerType}
            destinationvalue={fieldNames.timeoutrouting}
            executeSetting={executeSetting}
            aaFlag={aaFlag}
            disabledOperator={!watch(fieldNames.timeoutFlag)}
            assocCallFlows={assocCallFlows}
            innerRoute={true}
            routingname={fieldNames.timeoutrouting}
          />

          <div className="d-flex align-items-center justify-content-between mt-2">
            <label htmlFor="CheckBox1" className="fw-bold">
              Caller ID Pass Through
            </label>
            <MDBCheckbox
              name={`CheckBox${command ? `_${command}` : ""}`}
              id={`CheckBox${command ? `_${command}` : ""}`}
              checked={watch(fieldNames.cidPassFlag)}
              onChange={(e) => {
                setValue(fieldNames.cidPassFlag, e.target.checked, {
                  shouldDirty: true,
                });
                if (e.target.checked) {
                  // setValue(fieldNames.cidPass, "", { shouldDirty: true });
                }
              }}
            />
          </div>
          <div className="w-100">
            <Controller
              name={fieldNames.cidPass}
              control={control}
              rules={{
                validate: (value) => {
                  if (watch(fieldNames.cidPassFlag)) {
                    return true;
                  }

                  if (!value) {
                    return "Caller ID is required";
                  }

                  return validatePhoneNumber(value);
                },
              }}
              render={({ field }) => (
                <>
                  <MDBSelect
                    disabled={watch(fieldNames.cidPassFlag)}
                    name={fieldNames.cidPass}
                    value={watch(fieldNames.cidPass) ?? ""}
                    search
                    onChange={(e) => {
                      if (
                        e &&
                        e.value &&
                        e.value !== cidPassValue &&
                        e.value !== -1
                      ) {
                        clearErrors(fieldNames.cidPass);
                        setValue(fieldNames.cidPass, e.value, {
                          shouldDirty: true,
                        });
                      }
                    }}
                    data={[
                      { value: "-1", text: "Choose Caller ID" },
                      ...CallerList?.map((item) => ({
                        value: item.phnum,
                        text: item.addl_info,
                      })),
                    ]}
                  />
                  {getError(fieldNames.cidPass) && (
                    <p className="text-danger">
                      {getError(fieldNames.cidPass)}
                    </p>
                  )}
                </>
              )}
            />
          </div>
        </>
      )}
    </>
  );
}

export default BusyNoAnswerRoute;
